import { Injectable } from '@angular/core';
import { interval, Subject, Observable } from 'rxjs';
import { SwUpdate } from '@angular/service-worker';

@Injectable({ providedIn: 'root' })
export class UpdateSerive {

  private timesPrompted = 0;

  public updated = new Subject();

  constructor(public updates: SwUpdate) {
    if (updates.isEnabled) {
      interval(10 * 60 * 1000)
        .subscribe(() => updates.checkForUpdate());
    }
  }

  public checkForUpdates(): void {
    console.log('Buscando atualizações');
    this.updates.versionUpdates.subscribe(e => {
      this.timesPrompted++;
      if (this.timesPrompted > 1) {
        this.update();
      }
    });
  }

  private async update() {
    console.log('Atualizando aplicação');
    await this.updates.activateUpdate();
    if ('serviceWorker' in navigator) {
      const registrations = await navigator.serviceWorker.getRegistrations();
      for (const registration of registrations) {
        await registration.update();
      }
    }
    console.log('Aplicação atualizada com sucesso')
    this.updated.next();
  }

}
